import { Component, OnInit, HostListener, DOCUMENT } from '@angular/core';
import ConfettiGenerator from 'confetti-js';
import { PageScrollService } from 'ngx-page-scroll-core';
import { faCircleNotch, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Inject } from '@angular/core';


@Component({
  selector: 'xqnr-saved-to-xref',
  templateUrl: './saved-to-xref.component.pug',
  styleUrls: ['./saved-to-xref.component.scss'],
  standalone: false
})
export class SavedToXrefComponent implements OnInit {
  loaded = false;

  fa = {
    circleNotch: faCircleNotch,
    chevronDown: faChevronDown
  };

  confettiSettings = {
    target: 'confetti',
    colors: [
      [148, 213, 0],
      [244, 202, 36],
      [182, 228, 19],
      [212, 115, 230],
      [95, 157, 234]
    ],
    props: ['square', 'line'],
    rotate: true
  };

  blogPostConfig = [
    {
      title: 'thankYou.learnMore.postOne.title',
      link: 'https://employer.xref.com/',
      image: '/images/ty-view-dashboard.png'
    },
    {
      title: 'thankYou.learnMore.postTwo.title',
      link: 'https://employer.xref.com/request',
      image: '/images/ty-request-reference.png'
    },
    {
      title: 'thankYou.learnMore.postThree.title',
      link: 'https://help.xref.com/',
      image: '/images/ty-help-training.jpg'
    }
  ];

  constructor(
    private animateScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    new ConfettiGenerator(this.confettiSettings).render();
  }

  ngOnInit() {
    this.loaded = true;

    new ConfettiGenerator(this.confettiSettings).render();
  }

  scrollPastHeader() {
    this.animateScrollService.scroll({
      document: this.document,
      scrollTarget: '#headerEnd',
      duration: 500,
    });
  }
}
